export default __webpack_public_path__ + "static/6-bf9229cc52daa5af3e294a14be9e9319.jpg";